import { MutationFunction, useMutation } from '@tanstack/react-query'
import { MutationConfig } from '@/utils/reactQuery'
import apiClient from '@/utils/api'

const getApiDocUrl = async (): Promise<XMLHttpRequest> => {
  const response = await apiClient.get<unknown>('/documents/swagger')
  if (!(response.request instanceof XMLHttpRequest)) {
    throw new Error('Invalid request')
  }
  return response.request
}

type UseApiDocUrlOptions = {
  mutationConfig?: MutationConfig<MutationFunction<XMLHttpRequest, void>>
}

const useApiDocUrl = ({ mutationConfig }: UseApiDocUrlOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    onSuccess: (data, ...args) => {
      window.open(data.responseURL, '_blank')
      onSuccess?.(data, ...args)
    },
    ...restConfig,
    mutationFn: getApiDocUrl,
  })
}

export { getApiDocUrl, useApiDocUrl }
